import { useEffect } from 'react';
import { useAxios } from 'src/hooks/use-axios';

export type RemitInfo = { remitLink: string };

export function useRemitInfo() {
  const remitInfo = useAxios(
    (axios, signal) =>
      axios.request<RemitInfo>({
        signal,
        url: `${PRISMA_CONFIG.oldBackendUrl}/shippers/remit-info-link`,
      }),
    {
      neededOnPageLoad: true,
    }
  );

  useEffect(() => {
    remitInfo.execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return remitInfo;
}

export type RemitInfoRequest = ReturnType<typeof useRemitInfo>;
